'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _Sliders = require('scripts/components/Sliders');

var dom = {
  valueList: '[data-product-value-list]'
}; // Components


var initPropsValueSlider = function initPropsValueSlider() {
  var $valueList = $(dom.valueList);
  var windowWidth = $(window).width();

  if ($valueList.length <= 0) return;
  var propCount = $valueList.children().length;
  if (propCount > 5 || windowWidth < 699 && propCount > 2 || windowWidth < 991 && propCount > 3 || windowWidth < 1023 && propCount > 4) {
    var options = {};
    if ($valueList.data('arrow-left') && $valueList.data('arrow-right')) {
      options.prevArrow = '<button class="product-value__arrow product-value__arrow--left" type="button" aria-label="Go to previous slide">' + $valueList.data('arrow-left') + '</button>';
      options.nextArrow = '<button class="product-value__arrow product-value__arrow--right" type="button" aria-label="Go to next slide">' + $valueList.data('arrow-right') + '</button>';
    }
    (0, _Sliders.initSlider)('prop-values', options);
  }
};

var bindUIActions = function bindUIActions() {
  $(document).on('setPosition', dom.valueList, function () {
    var $valueList = $(dom.valueList);

    if ($valueList.length > 0) {
      var propCount = $valueList.find('.slick-slide:not(.slick-cloned)').length;

      if (propCount <= 5) {
        var windowWidth = $(window).width();
        if (windowWidth < 699 && propCount <= 2 || windowWidth >= 699 && windowWidth < 991 && propCount <= 3 || windowWidth >= 991 && windowWidth < 1023 && propCount <= 4 || windowWidth >= 1023) {
          $valueList.slick('unslick');
        }
      }
    }
  });

  $(window).on('resize', function (e) {
    var $valueList = $(dom.valueList);

    if ($valueList.length > 0 && !$valueList.hasClass('slick-initialized')) {
      var propCount = $valueList.children().length;

      if (propCount <= 5) {
        var windowWidth = $(window).width();
        if (windowWidth < 699 && propCount > 2 || windowWidth >= 699 && windowWidth < 991 && propCount > 3 || windowWidth >= 991 && windowWidth < 1023 && propCount > 4) {
          var options = {};
          if ($valueList.data('arrow-left') && $valueList.data('arrow-right')) {
            options.prevArrow = '<button class="product-value__arrow product-value__arrow--left">' + $valueList.data('arrow-left') + '</button>';
            options.nextArrow = '<button class="product-value__arrow product-value__arrow--right">' + $valueList.data('arrow-right') + '</button>';
          }
          (0, _Sliders.initSlider)('prop-values', options);
        }
      }
    }
  });
};

var initPropValues = function initPropValues() {
  bindUIActions();
  initPropsValueSlider();
};

var init = exports.init = function init() {
  var target = document.querySelector(dom.valueList);
  if (!target) return;
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          initPropValues();
          observer.unobserve(entry.target);
        }
      });
    });
    observer.observe(target);
  } else {
    initPropValues();
  }
};